var React = require('react');

function CloudSmall (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.000000,47.000000) scale(0.100000,-0.100000)","fill":"#ffffff","stroke":"none"},React.createElement("path",{"d":"M422 419 c-23 -12 -58 -40 -77 -62 -35 -41 -37 -41 -103 -42 -90 0\n-138 -25 -171 -88 -18 -36 -22 -54 -16 -84 9 -48 67 -107 120 -122 25 -7 151\n-11 340 -11 273 0 304 2 342 19 46 22 73 62 73 112 0 43 -54 96 -107 105 -36\n5 -40 10 -56 54 -20 57 -77 111 -136 128 -63 19 -160 15 -209 -9z"})));
}

CloudSmall.defaultProps = {"version":"1.0","width":"97.000000pt","height":"47.000000pt","viewBox":"0 0 97.000000 47.000000","preserveAspectRatio":"xMidYMid meet"};

module.exports = CloudSmall;

CloudSmall.default = CloudSmall;
